<template>
  <v-dialog
    v-model="modalState"
    transition="dialog-bottom-transition"
    persistent
    width="600"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          {{ $t("update_number_of_boxes") }}
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mt-4">
        <v-row class="pa-0">
          <v-col cols="12">
            <v-text-field
              :label="$t('number_of_boxes')"
              v-model="formData.number_of_boxes"
              dense
              outlined
              type="number"
              :min="0"
              @change="() => validateMinValue('number_of_boxes', 0, 'formData')"
              :error-messages="number_of_boxesErrors"
              @input="$v.formData.number_of_boxes.$touch()"
              @blur="$v.formData.number_of_boxes.$touch()"
            />
          </v-col>
        </v-row>
        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            @click.prevent="clearFields"
            type="reset"
            class="btn btn-light me-3 px-5 py-3 ls1"
          >
            Clear
          </button>
          <button
            @click.prevent="submitStatusUpdate"
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/own/mixins/validationMixin";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";

export default {
  name: "UpdateNumberOfBoxes",
  components: {},
  props: {
    refresher: { required: true, type: Function },
  },
  mixins: [validationMixin, fieldValueValidation],
  validations() {
    return {
      formData: {
        number_of_boxes: { required },
      },
    };
  },
  data: () => ({
    modalState: false,
    formData: {
      id: null,
      number_of_boxes: null,
    },
  }),
  computed: {
    number_of_boxesErrors() {
      return this.handleFormValidation("number_of_boxes", this);
    },
  },
  methods: {
    toggleModal(data) {
      if (!this.modalState) {
        this.formData.id = data.id.id;
        this.loadDataFromServer();
      } else this.clearFields();
      this.modalState = !this.modalState;
    },
    loadDataFromServer() {
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = { id: this.formData.id };
      ApiService.post("/fulfillment/orders/update_number_of_boxes", data)
        .then((response) => {
          this.formData.number_of_boxes = response.data.number_of_boxes;
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch(() => {
          this.dialog = false;
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },

    submitStatusUpdate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(`/fulfillment/orders/update_number_of_boxes`, {
        ...this.formData,
      })
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "Comments are added",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.refresher();
          this.toggleModal();
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    clearFields() {
      this.$v.$reset();
      this.formData = {
        number_of_boxes: null,
        id: null,
      };
    },
  },
};
</script>
